/* Enkindle 09/10/2026: copy the GA4 client id + session id onto the cart (hidden _ attributes) so the
   server-side purchase (Shopify order webhook -> Stape sGTM -> GA4) is credited to the same visitor and
   session, and GA4 dedupes it against the browser purchase. Safe to remove: delete this file and its
   script tag in layout/theme.liquid; the sGTM tag then skips every order. */
(function () {
  var MID = '46M90PZGJX';
  function ck(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function ids() {
    var ga = ck('_ga'), s = ck('_ga_' + MID), cid = '', sid = '';
    if (ga) { var p = ga.split('.'); if (p.length >= 4) cid = p[p.length - 2] + '.' + p[p.length - 1]; }
    if (s) { var m = s.match(/^GS2\.\d+\.s(\d+)/); if (m) sid = m[1]; else { var q = s.split('.'); if (q.length > 2 && /^\d+$/.test(q[2])) sid = q[2]; } }
    return { cid: cid, sid: sid };
  }
  var busy = false, of = window.fetch;
  function sync(force) {
    if (busy || !of) return; busy = true;
    of.call(window, '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!force && !cart.item_count) { busy = false; return; }
      var v = ids(), a = cart.attributes || {}, st = v.cid ? 'ga' : 'noga';
      if (a._lg_ga_cid === v.cid && a._lg_ga_sid === v.sid && a._lg_ga_state === st) { busy = false; return; }
      return of.call(window, '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _lg_ga_cid: v.cid, _lg_ga_sid: v.sid, _lg_ga_state: st } }) }).then(function () { busy = false; });
    }).catch(function () { busy = false; });
  }
  window.addEventListener('load', function () { setTimeout(function () { sync(false); }, 2500); });
  if (of) {
    window.fetch = function (input, init) {
      var u = (input && input.url) || input, p = of.apply(this, arguments);
      try { if (typeof u === 'string' && /\/cart\/(add|change)(\.js)?/.test(u)) p.then(function () { setTimeout(function () { sync(true); }, 400); }, function () {}); } catch (e) {}
      return p;
    };
  }
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) setTimeout(function () { sync(true); }, 1500); }, true);
})();
